import React, { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import axios from 'axios';

import { QuotationManagement, Quatations } from './QuatationCRUD';
import Notes from "./Notes";
import { Printer, AddwithWhiteCircle, UpdatePencil, SearchBig, DropdowArrow, Truckbody, Tires, Road } from '../../components/AllSvg';
import WorkType from './WorkType';
import { handleErrorToast } from '../../components/CustomFunctions';
import QuatationDietails from './QuatationDietails';
import { BASE_URL3 } from '../../config/axios';
import BankingDietails from './BankingCrud';
import AuthorityDietails from './AuthorityCrud';
import './quotationSlip.css';
// 👇 Apni CSS file ka sahi path daalo (jisme ViewProject + modal CSS hai)
import '../project/css/viewproject.css';

// ========================= 🔹 INVOICE PAGE =========================
const QuotationSlip = () => {
    const ref = useRef();

    const handlePrint = useReactToPrint({
        contentRef: ref,
        bodyClass: "print-agreement",
        documentTitle: "Quotation",
        pageStyle: `
      @page { size: A4 portrait; margin: 0; }
      html, body { margin: 0; padding: 0; }
      * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    `,
    });

    return (
        <>
            <div className="flex-column flex-center" style={{ minHeight: "fit-content" }}>
                <div className="printSlip-width flex-row justify-evenly button-margin">
                    <button className="btn-animated" onClick={handlePrint}>
                        <span className="btn-content">
                            <Printer /> Print
                        </span>
                        <span className="btn-ripple" />
                    </button>
                </div>
            </div>

            <QuotationManagement ref={ref} />
        </>
    );
};

// ========================= 🔹 QUOTATION MANAGE PAGE =========================
const TABS = [
    { id: 1, label: 'Work Type' },
    { id: 2, label: 'Notes' },
    { id: 3, label: 'Quotation' },
    { id: 4, label: 'Banking Details' },
    { id: 5, label: 'Authority Details' },
];

const Quotationmanage = () => {
    const [toggleState, setToggleState] = useState(1);

    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);

    const [worktypeName, setworktypeName] = useState([]);
    const [notesList, setnotesList] = useState([]);
    const [quatationList, setquatationList] = useState([]);
    const [bankingDetail, setBankingDetail] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const getBankingDetail = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL3}/project/bankingname/`);
            setBankingDetail(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };




    useEffect(() => {
        getBankingDetail();
    }, []);


    const [authorityDetail, setAuthorityDetail] = useState([]);
    const getAuthorityDetail = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL3}/project/authoritydetails/`);
            setAuthorityDetail(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getAuthorityDetail();
    }, []);

    // 🔹 API Calls
    const getworktypeName = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL3}/project/worktype/`);
            setworktypeName(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    const getNotesData = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL3}/project/note/`);
            setnotesList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };

    const getQuatationdata = async () => {
        setBuffering2(true);
        try {
            const res = await axios.get(`${BASE_URL3}/project/quotations/`);
            setquatationList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering2(false);
        }
    };

    useEffect(() => {
        getworktypeName();
        getNotesData();
        getQuatationdata();
    }, []);

    return (
        <div className="progress-modern-container">
            {/* 🔹 Tab Navigation */}
            <div className="table-wrapper-minimal">
                <div className="clean-tabs">
                    {TABS.map((tab) => (
                        <button
                            key={tab.id}
                            type="button"
                            className={`clean-tab ${toggleState === tab.id ? 'active' : ''}`}
                            onClick={() => setToggleState(tab.id)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                {/* 🔹 Tab Content */}
                <div className="quotation-tab-content">
                    {toggleState === 1 && (
                        <WorkType worktypeName={worktypeName} getData={getworktypeName} buffer={buffer} />
                    )}
                    {toggleState === 2 && (
                        <Notes worktypeName={worktypeName} notesData={notesList} getData={getNotesData} buffer={buffer1} />
                    )}
                    {toggleState === 3 && (
                        <QuatationDietails
                            worktypeName={worktypeName}
                            notesData={notesList}
                            quatationData={quatationList}
                            getData={getQuatationdata}
                            buffer={buffer2}
                            bankList={bankingDetail}
                            authorityList={authorityDetail}
                        />
                    )}
                    {toggleState === 4 && <BankingDietails />}
                    {toggleState === 5 && <AuthorityDietails />}
                </div>
            </div>
        </div>
    );
};

export { QuotationSlip, Quotationmanage };